import React, { ReactNode, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { HttpStatusCode } from "axios";

import { getLocalValue } from "../../../libs/localStorage";
import { reissueToken } from "../../../libs/request";

import { useUserContext } from "../../../contexts/userContext";

import { getMemberInfo } from "../../../services/memberServices";
import { logout } from "../../../services/authServices";

import useAppVersion from "../../../hooks/useAppVersion";
import usePushKey from "../../../hooks/usePush";
import userMemberInfo from "../../../hooks/useMemberInfo";
import { useDeviceType } from "../../../hooks/useDeviceType/Index";

type Props = { children: ReactNode };

export default function AuthGuard({ children }: Props) {
  const navigate = useNavigate();
  const location = useLocation();
  const deviceType = useDeviceType();
  const [, { updateField }] = useUserContext();
  const [appVersionResult, versionCall] = useAppVersion();
  const [, pushCall] = usePushKey();
  const { loadingUserData } = userMemberInfo({
    updateField,
    pushCall,
    deviceType,
    appVersion: appVersionResult.result,
  });

  const loginCheck = async () => {
    const isLogin = getLocalValue("jwtToken");
    if (!isLogin) return false;

    try {
      const res = await getMemberInfo();
      if (res.status === HttpStatusCode.Ok) {
        await updateField({ ...res.data });
      } else {
        return false;
      }
    } catch (e: any) {
      if (e?.response?.status === HttpStatusCode.Unauthorized) {
        logout();
      } else {
        return false;
      }
    }
    return true;
  };

  const checkSession = async () => {
    const isLogin = await loginCheck();
    if (isLogin === false) {
      const isAutoLogin = getLocalValue("AUTO");
      if (!isAutoLogin) {
        navigate(`/auth/login?redirect=${location.pathname}${location.hash}`, {
          replace: true,
        });
      } else {
        try {
          await reissueToken({ refreshToken: isAutoLogin });
        } catch (e: any) {
          console.log("reissueToken error", e);
        }
      }
    } else {
      console.log("기존 로그인 정보로 로그인 성공");
    }

    loadingUserData();
  };

  useEffect(() => {
    versionCall();

    checkSession();
  }, []);

  return <>{children}</>;
}
